import React from "react";

const TwitterIcon = ({ ...props }) => (
  <svg
    width="40"
    height="41"
    viewBox="0 0 40 41"
    fill="none"
    {...props}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0)">
      <path
        d="M12.5836 36.3751C27.6742 36.3751 35.9305 23.8696 35.9305 13.0282C35.9305 12.6767 35.9227 12.3173 35.907 11.9657C37.5131 10.8042 38.8992 9.36555 40 7.71729C38.5042 8.3828 36.9161 8.81743 35.2898 9.00636C37.0021 7.97998 38.2842 6.36758 38.8984 4.46807C37.2876 5.42273 35.526 6.09615 33.6891 6.45948C32.4514 5.1444 30.815 4.27366 29.0328 3.98188C27.2506 3.69011 25.422 3.99355 23.8296 4.84529C22.2372 5.69703 20.9697 7.04964 20.2231 8.69398C19.4765 10.3383 19.2924 12.1828 19.6992 13.9423C16.4375 13.7786 13.2466 12.9313 10.3333 11.4553C7.42004 9.97928 4.84949 7.90752 2.78828 5.37432C1.74067 7.18054 1.42009 9.31787 1.89172 11.3519C2.36334 13.386 3.59177 15.1642 5.32734 16.3251C4.02438 16.2837 2.74996 15.9329 1.60938 15.3017V15.4032C1.60821 17.2987 2.2635 19.1361 3.46385 20.6031C4.6642 22.0701 6.33554 23.0761 8.19375 23.4501C6.98676 23.7803 5.71997 23.8285 4.49141 23.5907C5.01576 25.2209 6.03595 26.6466 7.40962 27.669C8.78328 28.6914 10.4419 29.2595 12.1539 29.2939C9.24737 31.577 5.65696 32.8153 1.96094 32.8095C1.30548 32.8085 0.650665 32.7683 0 32.6892C3.75476 35.098 8.12255 36.3774 12.5836 36.3751Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect
          width="40"
          height="40"
          fill="white"
          transform="translate(0 0.125031)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default TwitterIcon;
